document.addEventListener('DOMContentLoaded',function() {

    const quiz = document.getElementById('quiz');
   
    const init = function() {

		const results = document.getElementsByClassName('js-quizresults')[0],
		      message = document.getElementsByClassName('js-message')[0],
		      overlay = document.getElementById('overlay');
		
		const formDataLength = function(fd) {
    		let i = 0;
    		for (var pair of fd.entries()) {
               i++;
            }
            return i;
		}
		
		const countPoints = function(fd) {
    		let i = 0;
    		for (var pair of fd.entries()) {
               i = i + parseInt(pair[1]);
            }
            return i;
		};
		
		const showResults = function(fd) {
    		
    		let answer = results.getElementsByTagName('li');
    		
    		console.log(countPoints(fd));
    		
    		for (let i = 0; i < answer.length; i++) {
        		answer[i].classList.add('is-hidden');
    		}
    		
    		if (countPoints(fd) >= 14) {
        		answer[0].classList.remove('is-hidden');
                console.clear();
                console.log(countPoints(fd) + 'great');
                
            } else if (countPoints(fd) >= 8) {
                answer[1].classList.remove('is-hidden');
                console.clear();
                console.log(countPoints(fd) + ' good');                
                
            } else if (countPoints(fd) <= 7) {
                answer[2].classList.remove('is-hidden');
                console.clear();
                console.log(countPoints(fd) + ' weak');
            }  
    		
            message.classList.add('is-hidden');
            overlay.classList.remove('is-hidden');
            
            setTimeout(function() {
                overlay.classList.add('is-visible');
            }, 100);
        };
	
		const handleFormSubmit = function(form) {
            
            const formData = new FormData(form);
            console.log(formDataLength(formData));
            formDataLength(formData) === 10 ? showResults(formData) : message.classList.remove('is-hidden');
		};
		
		
		quiz.addEventListener("submit", function(e) {
            e.preventDefault();
            handleFormSubmit(quiz);
        });		
	};

    quiz ? init() : false;
    
    
}, false);